import React from 'react';
import toastr from 'toastr';
import OnboardingProvidePersonalDetailsModal from './onboarding-provide-personal-details-modal';
import OnboardingSelectInvestorTypeModal from './onboarding-select-investor-type-modal';
import OnboardingSelectInvestmentThemesModal from './onboarding-select-investment-themes-modal';
import { getStepsToComplete } from '../../services/onboarding-services';
import ErrorBoundary from '../../shared/error-boundary';

export default class OnboardingWizard extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.onStepComplete = this.onStepComplete.bind(this);

    this.state = {
      loaded: false,
      stepsToComplete: {},
      activeStep: null,
    };
  }

  componentDidMount() {
    getStepsToComplete().then(result => this.setState(state => {
      state.stepsToComplete = result.data.steps_to_complete;
      state.loaded = true;
      const stcKeys = Object.keys(state.stepsToComplete);
      state.activeStep = stcKeys.length && stcKeys[0];
      return state;
    })).catch(err => toastr.error(err, 'Error'));
  }

  componentDidUpdate() {
    if (this.state.activeStep) {
      if (!this.isDetailsStep) {
        window.location = '/onboarding';
      } else {
        this.$overlay.show();
      }
    }
  }

  onStepComplete() {
    const { nextStepKey } = this;

    if (nextStepKey == null) {
      this.closeWizard();
      return;
    }

    this.setState({ activeStep: nextStepKey });
  }

  get nextStepKey() {
    const stepKeys = Object.keys(this.state.stepsToComplete);
    const activeStepIndex = stepKeys.indexOf(this.state.activeStep);

    if (activeStepIndex === -1 || stepKeys.length === activeStepIndex + 1) {
      return null;
    }

    return stepKeys[activeStepIndex + 1];
  }

  get isDetailsStep() {
    return this.state.activeStep === 'provide_personal_details';
  }

  closeWizard() {
    this.setState({ activeStep: null });
    this.$overlay.fadeOut(800, () => {
      window.location.reload();
    });
  }

  render() {
    if (!this.state.loaded) {
      return null;
    }

    const { activeStep, stepsToComplete: stc } = this.state;
    const { isDetailsStep } = this;

    if (activeStep && !isDetailsStep) {
      return null;
    }

    const isTypeStep = activeStep === 'select_investor_type';
    const isThemeStep = activeStep === 'select_investment_themes';
    const investorTypes = isTypeStep ? stc.select_investor_type.investor_types : [];
    const currentStepIndex = Object.keys(stc).indexOf(activeStep);
    const totalStepCount = Object.keys(stc).length;
    const assetClasses = isThemeStep ? stc.select_investment_themes.asset_classes : [];

    return (
      <ErrorBoundary>
        <div
          ref={el => (this.$overlay = $(el))}
          className="livewire-modal-overlay onboarding-modal-overlay"
        />
        <OnboardingProvidePersonalDetailsModal
          active={isDetailsStep}
          onComplete={this.onStepComplete}
          currentStepIndex={currentStepIndex}
          totalStepCount={totalStepCount}
          provideName={isDetailsStep && stc.provide_personal_details.provide_name}
          providePassword={isDetailsStep && stc.provide_personal_details.provide_password}
        />
        <OnboardingSelectInvestorTypeModal
          active={isTypeStep}
          onComplete={this.onStepComplete}
          investorTypes={investorTypes}
          currentStepIndex={currentStepIndex}
          totalStepCount={totalStepCount}
        />
        <OnboardingSelectInvestmentThemesModal
          active={isThemeStep}
          onComplete={this.onStepComplete}
          assetClasses={assetClasses}
          currentStepIndex={currentStepIndex}
          totalStepCount={totalStepCount}
        />
      </ErrorBoundary>
    );
  }
}
